import { Add, ErrorOutline, KeyboardArrowDown, MoreHorizOutlined } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import React, { useEffect, useState } from "react";
import AddUserModal from "../modals/AddUserModal";
import UserInvitedModal from "../modals/UserInvitedModal";
import axios from "axios";
import UpdateUserModal from "../modals/updateUserModa";
import planData from '../plans.json';
import DeleteUserModal from "../modals/DeleteUserModal";

const Users = () => {
  const [openAddUserModal, setOpenAddUserModal] = useState(false);



  
  const [openUserInvitedModal, setOpenUserInvitedModal] = useState(false);
  console.log(JSON.parse(localStorage.getItem("organization")).users.L);
  const [loader, setLoader] = useState(false);
 const [error_msg, setErrorMsg] = useState(null);

  const [planDetails, setPlanDetails] = useState(null);
  const check_subscription = async () => {
    try {
      setLoader(true)
      let sub = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "stripe/check-subscription",
        {
          customer_id: JSON.parse(localStorage.getItem("organization")).subscription_details.M.stripe_cust_id.S,
          sub_id: JSON.parse(localStorage.getItem("organization")).subscription_details.M.stripe_sub.S,
        }
      );

      console.log(sub.data)

      console.log(planData[sub.data?.planDetails[0].plan_id])
      setPlanDetails(planData[sub.data?.planDetails[0].plan_id])
      return;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrorMsg(error.response.data.message);
      }
      setLoader(false);
    }
 };
 useEffect(() => {
  check_subscription()
}, [])

  
  const [users_data, setUsersData] = useState(
    JSON.parse(localStorage.getItem("organization")).users.L
  );
  const [users, setUsers] = useState([]);
  const fetchUsers = async () => {
    let users_data =  JSON.parse(localStorage.getItem("organization")).users.L
    if (users_data) {
      setLoader(true)
      const fetchedUsers = await Promise.all(
        users_data.map(async (item) => {
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
              { userId: item.M.userId.S } // Extract userId from item
            );

            // Extract and map the necessary information]
            setLoader(false)
            return {
              name: `${response.data.user.fName.S} ${response.data.user.lName.S}`,
              email: response.data.user.email.S,
              userType: item.M?.type?.S, // Extract userType from item
              status: item.M.status.S, // Extract status from item
              user_id: response.data.user.userId.S, // Extract userId
            };
          } catch (error) {
            console.error("Error fetching user:", error);
            return null; // Handle the error gracefully
            setLoader(false)
          }
        })
      );

      // Filter out any null responses and update the state
      setUsers(fetchedUsers.filter((user) => user !== null));
      console.log('fet',fetchedUsers.filter((user) => user !== null))
      setLoader(false)
    }
  };

  useEffect(() => {
   
    fetchUsers();
    console.log('users', users)
  }, [users_data]);

  return (
    <div className=" px-3 lg:px-0 py-4 lg:py-0">
        {error_msg && (
        <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
          <ErrorOutline sx={{ fontSize: "" }} /> {error_msg}
        </div>
      )}
      {
        (users && users.filter((e)=> e.email ===  JSON.parse(localStorage.getItem('user')).email.S)[0]?.userType  !== 'user'  )? (
         <>

          <div className="flex justify-end">
        <AddUserModal
          users = {users}
          setUsers={setUsers}
          open={openAddUserModal}
          setOpen={setOpenAddUserModal}
          setOpenUserInvitedModal={setOpenUserInvitedModal}
          planDetails= {planDetails}
          fetchUsers={fetchUsers}
          loader ={loader}
          setLoader={setLoader}
        />
        <UserInvitedModal
          open={openUserInvitedModal}
          setOpen={setOpenUserInvitedModal}
          email={(users && users.length > 0) && users[users.length - 1].email}
        />

    
          <div className="">

          {loader ? (
            <CircularProgress size={"1.2rem"}   sx={{ color: "#605BFF", animationDuration: "0.7s", }} />
          ) : (<Button
             sx={{
               textTransform: "none",
               bgcolor: "#605BFF",
               color: "white",
               py: { lg: "10px", xs: "5px" },
               px: "20px",
               borderRadius: "12px",
               fontSize: { lg: "14px", xs: "12px" },
             }}
             onClick={() => setOpenAddUserModal(true)}
           >
             <Add
               sx={{
                 fontSize: { lg: "20px", xs: "15px" },
                 position: "relative",
                 bottom: 1,
               }}
             />
             Add User
           </Button>)}
         </div>
       
      </div>
       <div className="mt-4">
          <UserList
          error_msg={error_msg} setErrorMsg={setErrorMsg}
          users={users} loader={loader} setLoader={setLoader} setUsers={setUsers} fetchUsers={fetchUsers} />
        </div>
        </>
        ): (
          <Alert color='warning'>
            <div className=" text-black-600 text-[14px] ">
         You can't view this page in this organization because your type is user
        </div>
          </Alert>
        )
      }
      
    </div>
  );
};

const UserList = ({ users, loader,setLoader, setUsers, fetchUsers, error_msg,setErrorMsg }) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [anchorEl, setAnchorEl] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const handleClick = (event, index) => {
    setAnchorEl((prev) => ({ ...prev, [index]: event.currentTarget }));
    setCurrentIndex(index); // Track the index of the clicked row
  };

  const handleClose = (index) => {
    setAnchorEl((prev) => ({ ...prev, [index]: null }));
    setCurrentIndex(0); // Reset current index
  };

 

  const removeUser = async ( user_id ) => {
    setLoader(true);
    setErrorMsg(null)
    console.log(
    {
       user_id,
      organization_id: JSON.parse(localStorage.getItem("organization"))
        .orgId.S,
    })

      let check= await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
                      userId: JSON.parse(localStorage.getItem('user')).userId.S
                  });
                  
                  if (check.status ===  200) {
                    const user___ = check.data.user;
                    
              
                    if(user___.relatedOrgs.L?.find((e)=> e?.M.org_id?.S ===  JSON.parse(localStorage.getItem('organization')).orgId.S)){
                      try {
                        let user_data = await axios.post(
                          process.env.REACT_APP_BACKEND_URL + "delete-user",
                          {
                            user_performing_action_id: JSON.parse(localStorage.getItem("user")).userId.S,
                            user_id,
                            organization_id: JSON.parse(localStorage.getItem("organization"))
                              .orgId.S,
                          }
                        );
                        localStorage.setItem(
                          "organization",
                          JSON.stringify(user_data.data.updatedItem)
                        );
                        let related_org = await axios.post(
                          process.env.REACT_APP_BACKEND_URL + "delete-related-org",
                          {
                             user_id,
                            organization_id: JSON.parse(localStorage.getItem("organization"))
                              .orgId.S,
                          }
                        );
                  
                  
                        setUsers(users.filter((e)=> e.user_id !== user_id))
                  
                        setLoader(false);
                      } catch (error) {
                        console.log(error);
                        if (error.response && error.response.data) {
                          console.error("Response data:", error.response.data);
                         setErrorMsg( error.response.data.message);
                        }
                        setLoader(false);
                      }
                        
                    }else{
                      window.location.reload()
                    }
          
                  }
  };

  console.log({ users });

  const rows = [
    {
      name: "slack.png",
      email: "Slack",
      userType: "Main Slack",
      status: "pending",
    },
    {
      name: "slack.png",
      email: "Slack",
      userType: "Main Slack",
      status: "inactive",
    },
    {
      name: "slack.png",
      email: "Slack",
      userType: "Main Slack",
      status: "active",
    },
    // Add more rows here as needed
  ];

  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction:
        prevConfig.key ===  key && prevConfig.direction ===  "asc"
          ? "desc"
          : "asc",
    }));
  };

  const sortedRows = [...users].sort((a, b) => {
    if (sortConfig.key) {
      const isAscending = sortConfig.direction ===  "asc";
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (aValue < bValue) {
        return isAscending ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAscending ? 1 : -1;
      }
    }
    return 0;
  });

  const renderSortIcon = (key) => {
    if (sortConfig.key ===  key) {
      return sortConfig.direction ===  "asc" ? (
        <ArrowDropUpIcon fontSize="small" />
      ) : (
        <ArrowDropDownIcon fontSize="small" />
      );
    }
    return <ArrowDropDownIcon fontSize="small" className="opacity-50" />; // default icon
  };


  const [openUpdateUserModal, setOpenUpdateUserModal] = useState(false);
  const [openDeleteUserModal, setOpenDeleteUserModal] = useState(false);

  return (
    <TableContainer className="w-full verflow-x-auto lg:overflow-hidden">
      <Table className="no-borders" style={{ minWidth: "1100px" }}>
        <TableHead className="  ">
          <TableRow>
            <TableCell className="font-semibold cursor-pointer">Name</TableCell>
            <TableCell className="font-semibold cursor-pointer">
              Email
            </TableCell>
            <TableCell className="font-semibold cursor-pointer">
              User Type
            </TableCell>

            <TableCell
              className="font-semibold cursor-pointer "
              style={{ textAlign: "", border: "none" }}
            >
              Status
            </TableCell>
            <TableCell className="font-semibold cursor-pointer"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedRows.map((row, index) => (
            <TableRow
              key={index}
              className={index % 2 ===  0 ? "bg-white " : "bg-[#FAFAFB]"}
              sx={{ border: "none" }}
            >
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.email}</TableCell>
              <TableCell><div className="capitalize">{row.userType}</div></TableCell>

              <TableCell>
                {row.status ===  "pending" && (
                  <div className="text-[#FF8F6B] bg-[rgba(255,143,107,0.1)] text-center py-2 w-fit px-4 rounded-[20px]">
                    Pending
                  </div>
                )}

                {row.status ===  "active" && (
                  <div className="text-[#5B93FF] bg-[rgba(91,147,255,0.1)] text-center py-2 w-fit px-4 rounded-[20px]">
                    Active
                  </div>
                )}

                {row.status ===  "inactive" && (
                  <div className="text-[#FF8F6B] bg-[rgba(255,143,107,0.1)] text-center py-2 w-fit px-4 rounded-[20px]">
                    Inactive
                  </div>
                )}
              </TableCell>
              <TableCell>
                <MoreHorizOutlined
                  sx={{ color: "#B3B3BF", cursor: "pointer",
 display: (sortedRows.filter((e)=> e.email ===  JSON.parse(localStorage.getItem('user')).email.S).userType  !== 'owner' && row.userType ===  'owner' )? 'none' :'block'

                   }}
                  onClick={(event) => handleClick(event, index)}
                  
                  
                />
                
                <Menu
                  anchorEl={anchorEl[index]}
                  open={Boolean(anchorEl[index])}
                  onClose={() => handleClose(index)}
                  PaperProps={{
                    elevation: 1, // Adds shadow
                    sx: {
                      bgcolor: "white", // Sets background color to white
                      overflow: "visible",
                      mt: 1.5,
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Custom shadow color
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        left: "14px",
                        width: 10,
                        height: 10,
                        bgcolor: "white", // Sets the arrow's background color to white
                        zIndex: 0,
                      },
                      borderRadius: "10px",
                      padding: 1, // Adds padding around the items
                       display: (sortedRows.filter((e)=> e.email ===  JSON.parse(localStorage.getItem('user')).email.S).userType  !== 'owner' && row.userType ===  'owner' )? 'none' :'block'
                    },
                  }}
                  transformOrigin={{ horizontal: "center", vertical: "top" }}
                  anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
                >
                  <UpdateUserModal open={openUpdateUserModal} setOpen={setOpenUpdateUserModal} users={users} setUsers={setUsers} user_data={sortedRows[currentIndex]} fetchUsers={fetchUsers} sortedRows={sortedRows}/>
                  <DeleteUserModal open={openDeleteUserModal} setOpen={setOpenDeleteUserModal} removeUser={removeUser} user_id={row.user_id} closeMenu={handleClose} index={index} />
                  <MenuItem
                    onClick={() =>
                      {
                      
                        setOpenUpdateUserModal(true)
                      }
                      
                    }
                    sx={{
                      bgcolor: "rgba(91,147,255,0.1)",
                      borderRadius: "8px",
                      mb: 0.5,
                      padding: "10px 16px", // Adds padding inside each item
                      fontSize: "14px",
                       display: (sortedRows.filter((e)=> e.email ===  JSON.parse(localStorage.getItem('user')).email.S).userType  !== 'owner' && row.userType ===  'owner' )? 'none' :'block'
                    }}
                  >
                    <div className="space-x-3 flex items-center">
                      <EditIcon fontSize="" color="primary" />
                      <div className="font-[14px] text-[#5B93FF] ">Edit</div>
                    </div>
                  </MenuItem>
                  <MenuItem
                   
                    onClick={() => {
                      console.log(row.user_id)
                      setOpenDeleteUserModal(true)
                   
                 

                    }}
                    sx={{
                      bgcolor: "rgba(231,29,54,0.1)",
                      borderRadius: "8px",
                      padding: "10px 16px", // Adds padding inside each item
                      fontSize: "14px",
                      display: (sortedRows.filter((e)=> e.email ===  JSON.parse(localStorage.getItem('user')).email.S).userType  !== 'owner' && row.userType ===  'owner' )? 'none' :'block'
                    }}
                  >
                    <div className="space-x-3 flex items-center">
                      <DeleteIcon fontSize="" sx={{ color: "#E71D36" }} />
                      <div className="font-[14px] text-[#E71D36]">Delete</div>
                    </div>
                  </MenuItem>
                </Menu>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Users;
